import type { Workspace as GraftcodeWorkspace } from '@graft/nuget-gc.webportals.workspaces'

import { workspaceToObject } from '@common/modules/workspaces/objects/workspace.object'

import type { Organization } from '../../types'
import { formatTimestampDate } from '../../utils'
import { ORGANIZATION_ROLE } from '../const'

export async function organizationToObject(entity: GraftcodeWorkspace): Promise<Organization> {
  const workspace = await workspaceToObject(entity)
  return {
    id: workspace.id,
    name: workspace.name,
    logo: [],
    logoUrl: workspace.logoUrl,
    joinedAt: formatTimestampDate(workspace.createdAt),
    role: ORGANIZATION_ROLE.OWNER,
  }
}
